import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
interface Flake {
  id: number;
  x: number;
  size: number;
  duration: number;
  delay: number;
  sway: number;
}
export function Snowflakes() {
  const [flakes, setFlakes] = useState<Flake[]>([]);
  useEffect(() => {
    // Generate static flakes on mount to avoid hydration mismatches
    // and keep them consistent
    const generatedFlakes = Array.from({
      length: 40
    }).map((_, i) => ({
      id: i,
      x: Math.random() * 100,
      size: Math.random() * 0.4 + 0.15,
      duration: Math.random() * 15 + 15,
      delay: Math.random() * -30,
      sway: Math.random() * 10 - 5 // -5% to 5% horizontal sway
    }));
    setFlakes(generatedFlakes);
  }, []);
  return <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden" aria-hidden="true" data-id="element-137">
      {flakes.map(flake => <motion.div key={flake.id} className="absolute top-[-5%] rounded-full bg-white/40 blur-[1px]" style={{
      left: `${flake.x}%`,
      width: `${flake.size}rem`,
      height: `${flake.size}rem`
    }} animate={{
      y: ['0vh', '110vh'],
      x: [`${flake.x}%`, `${flake.x + flake.sway}%`, `${flake.x - flake.sway}%`, `${flake.x}%`]
    }} transition={{
      y: {
        duration: flake.duration,
        repeat: Infinity,
        ease: 'linear',
        delay: flake.delay
      },
      x: {
        duration: flake.duration * 0.8,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: flake.delay
      }
    }} data-id="element-138" />)}
    </div>;
}